<template lang="html">
  <b-col md="5" lg="3" xl="2" class="recommendation-info">
    <p><span class="reportLabel">Cycle</span>{{ recommendation.cycle }}</p>
    <p><span class="reportLabel">Report Publish Date</span>{{ formattedDate }}</p>
    <p><span class="reportLabel">Report Number</span>{{ recommendation.reportNumber }}</p>
    <p><span class="reportLabel">Recommendation Number</span>{{recommendation.number}}</p>
  </b-col>
</template>

<script>
export default {
  props: ['recommendation'],
  data() {
    return {
      showResponses: false,
      showFindings: false
    }
  },
  computed: {
    buttonText() {
      if (this.showResponses) {
        return 'Hide Responses'
      }
      return 'Show Responses'
    },
    findingButtonText() {
      if (this.showFindings) {
        return 'Hide Findings'
      }
      return 'Show Findings'
    },
    formattedDate() {
      let date = new Date(this.recommendation.publishedDate)
      date = date.toLocaleString('default', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      })
      return date
    }
  },
  methods: {
    toggleResponse() {
      this.showResponses = !this.showResponses
      this.$emit('toggleResponse', this.showResponses)
    },
    toggleFinding() {
      this.showFindings = !this.showFindings
      this.$emit('toggleFinding', this.showFindings)
    }
  }
}
</script>

<style lang="css" scoped>
.custom-control {
  padding-left: 0;
}

.reportLabel {
  display: block;
  font-family: "Nunito", Arial, sans-serif;
  color: #223d6b;
  font-weight: bold;
  font-size: 0.8rem;
}

.recommendationText {
  font-size: .8rem;
}

.implementationStatus {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
}

.not_implemented {
  background-color: #E79E94;
  color: black;
}

.partially_implemented {
  background-color: #41A97A;
  color: white;
}

.fully_implemented {
  background-color: #147A4C;
  color: white;
}

.pending {
  background-color: #EDE8AF;
}

.will_not_implement {
  background-color: #BF211E;
  color: white;
}

.no_longer_applicable, .none {
  background-color: #C7C3C5;
  color: white;
}
</style>
